export default "<div class=\"map-container\" (click)=\"openClubMap()\">\n    <img #imgMap id=\"imgMap\" alt=\"\" height=\"100\"/>\n</div>\n";